<template>
  <div v-if="items.length !== 0" class="mapView">
    <div>
      <l-map
        v-if="items[0].geom.type.toLowerCase() === 'multipolygon'"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="min-height: 435px"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-polygon
          v-for="(ob, i) in items"
          :key="'marker-' + i"
          :lat-lng="ob.latLng"
          :filter="$parent.filter"
          :filter-included-fields="$parent.filterOn"
          @filtered="$parent.onFiltered"
        >
          <l-popup class="map-popup">
            <div v-show="showPointData">
              <!-- popup -->
              <b-row v-for="(ele, j) in fields" :key="'ele-' + j">
                <label>
                  <b>{{ ele }}: </b>
                </label>
                <span>{{ ob[ele] }}</span>
              </b-row>
            </div>
          </l-popup>
        </l-polygon>
      </l-map>
      <l-map
        v-if="items[0].geom.type.toLowerCase() === 'point'"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="min-height: 435px"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-marker
          v-for="(ob, i) in items"
          :key="'marker-' + i"
          :lat-lng="ob.latLng"
          :filter="$parent.filter"
          :filter-included-fields="$parent.filterOn"
          @filtered="$parent.onFiltered"
        >
          <l-popup class="map-popup">
            <div v-show="showPointData">
              <!-- popup -->
              <b-row v-for="(ele, j) in fields" :key="'ele-' + j">
                <label
                  ><b>{{ ele }}: </b></label
                >
                <span>{{ ob[ele] }}</span>
              </b-row>
            </div>
          </l-popup>
        </l-marker>
      </l-map>
    </div>
    <b-alert
      :show="alertTime"
      dismissible
      fade
      :variant="alertVariant"
      @dismiss-count-down="alertTimeChanged"
      >{{ alertMessage }}
    </b-alert>
  </div>
</template>

<script>
import Vue from "vue";
import proj4 from "@/util/proj4-module";
import { latLng, Icon } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LCircleMarker,
} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { mapState } from "pinia";
import { useCatalog } from "@/store/catalog";

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-circle-marker", LCircleMarker);
Vue.component("l-marker", LMarker);
Vue.component("l-popup", LPopup);
Vue.component("l-tooltip", LTooltip);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default Vue.extend({
  data: () => ({
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    center: latLng(53.27983586756578, -6.213194621186445),
    zoom: 6.5,
    currentZoom: 5,
    currentcenter: latLng(53.27983586756578, -6.213194621186445),
    showPointData: true,
    mapOptions: {
      zoomSnap: 0.5,
    },
    showMap: true,
    dpRequest: {},
    currentIndexSelected: 0,
    proj2157: proj4("EPSG:2157"),
    proj4326: proj4("EPSG:4326"),
    alertVariant: "success",
    alertTime: 0,
    alertMessage: null,
    dismissSecs: 4,
    items: [],
    fields: [],
  }),
  computed: {
    // ...mapGetters({
    //   catalogSelected: "catalog/getSelectedCatalog",
    //   itemsFromStore: "catalog/getCurrentItems",
    //   fieldsFromStore: "catalog/getCurrentFields",
    // }),
    ...mapState(useCatalog, [
      "selectedCatalog",
      "currentItems",
      "currentFields",
    ]),
  },
  mounted() {
    this.selfCallAddLatLng();
  },
  methods: {
    getLatLng(coords) {
      const x = proj4(this.proj2157, this.proj4326, coords)[0];
      const y = proj4(this.proj2157, this.proj4326, coords)[1];
      return latLng(y, x);
    },
    callAddLatLng() {
      this.addLatLng();
      return true;
    },
    selfCallAddLatLng() {
      setTimeout(() => {
        this.addLatLng();
      }, 4000);
    },
    addLatLng() {
      this.items = this.currentItems;
      this.fields = this.currentFields;
      if (this.fields[this.fields.length - 1] !== "latLng") {
        this.fields.push("latLng");
        this.items.forEach((ob) => {
          ob.latLng = this.getLatLng(ob.geom.coordinates);
        });
      }
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    toggleShowPointData() {
      this.showPointData = !this.showPointData;
    },
    alertTimeChanged(alertTime) {
      this.alertTime = alertTime;
    },
    showAlert(time, variant, msg) {
      this.alertTime = time;
      this.alertVariant = variant;
      this.alertMessage = msg;
    },
  },
});
</script>

<style scoped>
.map-popup {
  max-height: 200px;
  overflow-y: auto;
  padding-left: 15px;
}
.alert {
  position: fixed;
  top: 85px;
  right: 40px;
  min-width: 30vw;
  z-index: 1;
}
.mapView {
  padding: 40px 0px 15px 0px !important;
}
img {
  width: 100%;
  min-width: 200px;
  max-height: 30rem;
}
</style>
